import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/sith': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M0 32l118.8 69.7-11.5-58.9 91.1 69.9c8.5-1.5 17.1-2.3 25.7-2.3s17.2 0.8 25.7 2.3l91.1-69.9-11.5 58.9 118.8-69.7-69.7 118.8 58.9-11.5-69.8 91c3 17 3 34.4 0 51.5l69.8 91-58.9-11.5 69.7 118.8-118.8-69.7 11.5 58.9-91-69.8c-17 3-34.5 3-51.5 0l-91 69.8 11.5-58.9-118.8 69.7 69.7-118.8-58.9 11.5 69.8-91c-1.3-7-2.3-18.6-2.3-25.7 0-7.2 1-18.7 2.3-25.7l-69.8-91 58.9 11.5zM224 131.8c-31.8 0-63.6 12.1-87.8 36.3-48.5 48.5-48.5 127.2 0 175.7 48.5 48.5 127.2 48.5 175.7 0 48.5-48.5 48.5-127.2 0-175.7-24.3-24.3-56-36.4-87.8-36.4zM224 168.4c22.4 0 44.8 8.5 61.9 25.6 34.2 34.2 34.2 89.7 0 123.9-34.2 34.2-89.7 34.2-123.8 0-34.2-34.2-34.2-89.7 0-123.9 17.1-17.1 39.5-25.6 61.9-25.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/sith.js
// module id = 856
// module chunks = 0